
import { CityPoint } from "@/models/City";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
class BaseTable extends Vue {
  @Prop({ default: null }) readonly data!: [];
  @Prop({ default: false }) readonly whatType!: string;
  @Prop({ default: "" }) readonly slug!: string;
  @Prop({ default: "manhunt" }) readonly gameType!: string;
  @Prop({ default: "" }) readonly locationSlug!: string;
  items = [];
  busy = false;

  get getFields(): unknown {
    if (this.whatType === "FX") {
      return [
        {
          key: "slug",
          label: "Name",
          sortable: true,
        },
      ];
    } else if (this.whatType === "INV" && this.gameType === "manhunt") {
      return [
        {
          key: "slug",
          label: "Name",
          sortable: true,
        },
        {
          key: "quant",
          label: "Quantity",
          sortable: true,
        },
      ];
    } else if (this.whatType === "INV" && this.gameType === "quest") {
      return [
        {
          key: "slug",
          label: "Name",
          sortable: true,
        },
        {
          key: "quant",
          label: "Quantity",
          sortable: true,
        },
        {
          key: "type",
          label: "Item-Type",
          sortable: true,
        },
      ];
    } else if (this.whatType === "weapon") {
      return [
        {
          key: "name.en",
          label: "Name",
          sortable: true,
        },
        {
          key: "guilt",
          label: "Guilty?",
          sortable: true,
        },
      ];
    } else {
      return [{ key: "name.en", label: "Name", sortable: true }];
    }
  }

  mounted(): void {
    if (this.slug !== "") {
      if (this.$refs.myTable !== undefined) {
        var cityPoint = (this.data as unknown) as CityPoint[];
        let myTable = (this.$refs.myTable as Vue).$el as SVGElement,
          tableBody = myTable.getElementsByTagName("tbody")[0],
          tableRows = tableBody.getElementsByTagName("tr");
        var index = cityPoint.findIndex((x: CityPoint) => x.slug == this.slug);
        tableRows[index].scrollIntoView(false);
        tableRows[index].click();
      }
    }
  }

  @Watch("locationSlug")
  onLocationSlugChange(value: string): void {
    if (this.$refs.myTable !== undefined) {
      var cityPoint = (this.data as unknown) as CityPoint[];
      let myTable = (this.$refs.myTable as Vue).$el as SVGElement,
        tableBody = myTable.getElementsByTagName("tbody")[0],
        tableRows = tableBody.getElementsByTagName("tr");
      var index = cityPoint.findIndex((x: CityPoint) => x.slug == value);
      tableRows[index].scrollIntoView(false);
      tableRows[index].click();
    }
  }

  onRowSelected(rows: any): void {
    this.$emit("onRowSelected", rows[0]);
  }
}

export default BaseTable;
